import { create } from "zustand";

export interface ToastData {
  type: "success" | "error" | "warning" | "info";
  message: string;
  id?: string;
  duration?: number;
}

interface GlobalState {
  error: string | null;
  setError: (error: string | null) => void;
  clearError: () => void;

  toast: ToastData | null;
  setToast: (toast: ToastData | null) => void;
  clearToast: () => void;

  showSuccess: (message: string, duration?: number) => void;
  showError: (message: string, duration?: number) => void;
  showWarning: (message: string, duration?: number) => void;
  showInfo: (message: string, duration?: number) => void;
}

const useGlobalStore = create<GlobalState>((set, get) => ({
  error: null,
  setError: (error: string | null) => {
    set({ error });
    if (error) {
      get().showError(error);
    }
  },
  clearError: () => set({ error: null }),

  toast: null,
  setToast: (toast: ToastData | null) => set({ toast }),
  clearToast: () => set({ toast: null }),

  showSuccess: (message: string, duration = 4000) =>
    set({
      toast: {
        type: "success",
        message,
        id: Date.now().toString(),
        duration,
      },
    }),

  showError: (message: string, duration = 6000) =>
    set({
      toast: {
        type: "error",
        message,
        id: Date.now().toString(),
        duration,
      },
    }),

  showWarning: (message: string, duration = 5000) =>
    set({
      toast: {
        type: "warning",
        message,
        id: Date.now().toString(),
        duration,
      },
    }),

  showInfo: (message: string, duration = 4000) =>
    set({
      toast: {
        type: "info",
        message,
        id: Date.now().toString(),
        duration,
      },
    }),
}));

export default useGlobalStore;
